import {
  createResource,
  postResource,
} from '@/js/resource/resource'

import { TEST } from './paths'

export const testRequestResource = createResource(
  TEST.TEST_REQUEST, postResource
)
